// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RedebitListModel from '../../model/redebit-list-model';
import RedebitListDTO from '../dto/redebit-list-dto';
import dtoSchema from '../schemas/redebit-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class RedebitListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RedebitListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.entryDate = data.entryDate;
      this.transactionId = data.transactionId;
      this.debtorName = data.debtorName ?? undefined;
      this.amount = data.amount;
      this.currency = data.currency ?? undefined;
      this.uploadStatus = data.uploadStatus ?? undefined;
      this.uploadStatusReportDownloadDate = data.uploadStatusReportDownloadDate ?? undefined;
      this.paymentStatus = data.paymentStatus ?? undefined;
      this.paymentStatusReportDownloadDate = data.paymentStatusReportDownloadDate ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {date-time}
  */
  entryDate?: string;
  /**
  * @type {int32}
  */
  transactionId?: number;
  /**
  */
  debtorName?: string;
  /**
  * @type {double}
  */
  amount?: number;
  /**
  */
  currency?: string;
  /**
  * @type {int32}
  */
  uploadStatus?: number;
  /**
  * @type {date-time}
  */
  uploadStatusReportDownloadDate?: string;
  /**
  */
  paymentStatus?: string;
  /**
  * @type {date-time}
  */
  paymentStatusReportDownloadDate?: string;

  static toModel(dto: DeepPartial<RedebitListDTO>): RedebitListModel;
  static toModel(dto: DeepPartial<RedebitListDTO> | undefined | null): RedebitListModel | undefined;
  static toModel(dto: DeepPartial<RedebitListDTO> | undefined | null): RedebitListModel | undefined {
    return dto ? new RedebitListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RedebitListModel> | RedebitListModel): RedebitListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      entryDate: unwrapped.entryDate,
      transactionId: unwrapped.transactionId,
      debtorName: unwrapped.debtorName,
      amount: unwrapped.amount,
      currency: unwrapped.currency,
      uploadStatus: unwrapped.uploadStatus,
      uploadStatusReportDownloadDate: unwrapped.uploadStatusReportDownloadDate,
      paymentStatus: unwrapped.paymentStatus,
      paymentStatusReportDownloadDate: unwrapped.paymentStatusReportDownloadDate,
    } as RedebitListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RedebitListModel, can not map to RedebitListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
